<script>
import dayjs from '@/services/date'
import { mapGetters } from 'vuex'
export default {
  name: 'DateComponent',
  props: {
    date: {
      type: String,
      default: '',
    },
    dateTimezone: {
      type: String,
      default: 'NOT_SET',
    },
  },
  computed: {
    ...mapGetters({ returnUserTimeformat: 'auth/currentUserDateFormat' }),
    returnDateTime() {
      return dayjs(this.date).format(this.returnUserTimeformat)
    },
  },
}
</script>

<template>
  <div class="dateField"> {{ returnDateTime }} </div>
</template>

<style lang="scss" scoped>
.dateField {
  white-space: nowrap;
}
.consultantInfo {
  border: 1px SOLID #ccc;
  padding: 5px;
  margin: 3px;
  display: inline-block;
}
</style>
